
<template>
  <router-view></router-view>
  <GlobalLoginDialog />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import GlobalLoginDialog from '@/components/GlobalLoginDialog.vue'

export default defineComponent({
  name: 'App',
  components: {
    GlobalLoginDialog
  }
});
</script>

<style>
#app {
  font-family: Roboto-Regular,PingFang SC,SF Pro SC,SF Pro Text,SF Pro Icons,Helvetica Neue,Roboto,Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
}
a {
    text-decoration: none
}
button,
input,
textarea {
  color: inherit;
  font: inherit;
}
[class*=van-]:focus,
    a:focus,
    button:focus,
    input:focus,
    textarea:focus {
        outline: none
}
/* ol,
ul {
    margin: 0;
    padding: 0;
    list-style: none
} */
</style>
